import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Element } from "react-scroll";
import NavBar from "./Components/NavBar";
import Hero from "./Components/Hero";
import "./App.css";
//import WorkPage from "./Components/Work";
import AboutMe from "./Components/AboutUs/AboutMe";
import ContactMe from "./Components/ContactUs";
import Extracurricular from "./Components/AboutUs/ExtraCurricular";

function App() {
  return (
    <Router>
      <div className="App">
        <Element name="hero">
          <Hero />
        </Element>

        <Element name="about_us">
          <AboutMe />
        </Element>
        <Element name="extras">
          <Extracurricular />
        </Element>
        <Element name="contact_us">
          <ContactMe />
        </Element>
        <NavBar />
      </div>
    </Router>
  );
}

export default App;
